import * as Yup from 'yup';

export default function buildValidationSchema(availableMenus) {
  const schemaFields = {
    restaurantId: Yup.string().required('Restaurant ID is verplicht.'),
    date: Yup.string().required('Datum is verplicht.'),
    time: Yup.string().required('Tijd is verplicht.'),
    guests: Yup.number()
      .typeError('Aantal personen moet een nummer zijn.')
      .integer('Aantal personen moet een geheel getal zijn.')
      .min(1, 'Minimaal 1 persoon vereist.')
      .required('Aantal personen is verplicht.'),
    firstName: Yup.string().required('Voornaam is verplicht.'),
    lastName: Yup.string().required('Achternaam is verplicht.'),
    email: Yup.string().email('Voer een geldig e-mailadres in.').required('E-mailadres is verplicht.'),
    phone: Yup.string().required('Mobiel nummer is verplicht.'),
    extraInfo: Yup.string().notRequired(),
    giftcard: Yup.string().notRequired(),
  };

  if (availableMenus.length > 0) {
    schemaFields.menu = Yup.string().required('Menu is verplicht.');
  } else {
    schemaFields.menu = Yup.string().notRequired();
  }

  return Yup.object().shape(schemaFields);
}


